import type { DriverType } from '@ria-client/supergraph/marketplace/types';
import { DisclosureTooltip } from '@ria-client/tw-shared-ui';
import { CircleHelp } from 'lucide-react';

export interface DriverProps {
  driver: DriverType;
  className: string;
}

export function Driver({ driver, className }: DriverProps) {
  const shouldCapitalizeLabel = driver.id !== 'MINIMUM_BALANCE_FOR_APY';

  return (
    <div
      className={`flex flex-col items-center gap-1 px-3 pb-3 pt-2 text-center md:items-start md:text-left ${className}`}
    >
      <div className="flex items-center">
        <span
          className={`typography-text-small mb-1 text-[var(--content-neutral-darker)] ${shouldCapitalizeLabel ? 'capitalize' : ''}`}
          data-testid="product-card-driver-label"
        >
          {driver.label}
        </span>
        {driver.labelTooltip && (
          <DisclosureTooltip
            trigger={
              <button
                aria-label={`${driver.label} info`}
                className="ml-1 text-[var(--content-neutral-dark)]"
                type="button"
              >
                <CircleHelp aria-hidden size={14} />
              </button>
            }
          >
            <span className="typography-text-small">{driver.labelTooltip}</span>
          </DisclosureTooltip>
        )}
      </div>
      <div className="flex items-center">
        <span
          className="font-sans text-xl font-bold break-words"
          data-testid="product-card-driver-value"
        >
          {driver.value || 'N/A'}
        </span>
        {driver.valueTooltip && (
          <DisclosureTooltip
            trigger={
              <button
                aria-label={`More information about${driver.label}`}
                className="ml-1 text-[var(--content-neutral-dark)]"
                type="button"
              >
                <CircleHelp aria-hidden size={16} />
              </button>
            }
          >
            <span className="typography-text-small">{driver.valueTooltip}</span>
          </DisclosureTooltip>
        )}
      </div>
      {driver.description && (
        <span className="typography-text-small text-[var(--content-neutral-darker)]">
          {driver.description}
        </span>
      )}
    </div>
  );
}
